module.exports = __webpack_public_path__ + "static/media/1_r_kadirova_60.89_71.85.276ca7fb.png";